export const environment = {
   URL: 'https://repower.simadvisory.com/',
  KEYCLOAK_URL: 'https://auth.simadvisory.com/auth',
  KEYCLOAK_REALM: 'SPRICED_NRP',
  KEYCLOAK_CLIENT_ID: 'REPOWER_Client',
  PROJECT_ID: 'oh',
  HELP_URL: "https://google.com",
  COMPANY_LOGO_SRC: "https://assets.alpha.simadvisory.com/logos/image.png",
  COMPANY_LOGO_TEXT: "REPOWERS PREDICTOR TOOL",
  SECONDARY_LOGO_SRC: "https://assets.alpha.simadvisory.com/Make-in-india.png",
  SECONDARY_COLOR: '#9ccafb',
  SECONDARY_COLOR_2: '#9ccafb',
  ICON_URL: "https://assets.alpha.simadvisory.com/logos/image.png",
  TAB_NAME: "REPOWERS PREDICTOR TOOL",
  HELP_ENABLED: "true",
  FEEDBACK_URL: "https://docs.google.com/forms/u/0/",
  FEEDBACK_ENABLED: "true",
  NOTIFICATION_ENABLED: "true",
  USER_ENABLED: "true",
  LOGOUT_ENABLED: "true",
  agentApiUrl: 'http://localhost:8081',
  USE_ALT_SIDENAV: false,
  ALT_COMPANY_LOGO_SRC: 'https://repower.simadvisory.com/my-assets/cummins_white.png',
  ALT_SECONDARY_LOGO_SRC: 'https://repower.simadvisory.com/my-assets/sim-logo-white.png',
};
